import request from '@/utils/request';
export function typeList(data) {
  return request.post('admin/company-organization/list', data);
}
export function typeStatus(data) {
  return request.post('admin/company-organization/status', data);
}
export function typeIsEdit(data) {
  return request.post('admin/company-organization/isEdit', data);
}
export function typeDelete(data) {
  return request.post('admin/company-organization/delete', data);
}
export function addType(data) {
  return request.post('admin/company-organization/store', data);
}
export function editType(data) {
  return request.post('admin/company-organization/edit', data);
}
export function typeResource(data) {
  return request.post('admin/company-organization/resource', data);
}